import { Link, useNavigate, useParams } from "react-router-dom";
import moment from "moment-timezone";
import { twMerge } from "tailwind-merge";
import Layout from "../../layout.tsx/app";
import { useOfflineAsesmenStore } from "../offline-asesmen.store";
import { useEffect } from "react";
import { currency } from "../../../helper/currency";
import Table from "../../../components/tables/base";
import { Spinner } from "flowbite-react";

const DetailAsesmen = () => {
  const {
    offlineAssessment,
    getOfflineAssessment,
    loadingOfflineAssessment,
    participants,
    getParticipants,
    loadingParticipants,
  } = useOfflineAsesmenStore();

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    id && getOfflineAssessment(id);
  }, [getOfflineAssessment, id]);

  useEffect(() => {
    offlineAssessment && getParticipants(offlineAssessment.reg_id);
  }, [offlineAssessment, getParticipants]);

  return (
    <Layout
      withPageTitle={true}
      title={
        <div className="flex gap-2 items-center">
          <span>Asesmen #{offlineAssessment?.reg_id}</span>
          <small
            className={`text-xs uppercase text-gray-800 px-2 rounded ${
              offlineAssessment?.status === "draft" && "bg-gray-100"
            } ${
              offlineAssessment?.status === "pending approval" && "bg-blue-100"
            } ${offlineAssessment?.status === "approved" && "bg-green-100"}`}
          >
            {offlineAssessment?.status}
          </small>
        </div>
      }
      // pageTitleContent={
      //   offlineAssessment?.status === "pending approval" ? (
      //     <Button
      //       onClick={() => setModalApprove(true)}
      //       className="px-8 text-sm"
      //     >
      //       Setujui
      //     </Button>
      //   ) : (
      //     <></>
      //   )
      // }
    >
      {loadingOfflineAssessment ? (
        <>
          <div className="w-full h-48 bg-gray-100 animate-pulse mb-2 rounded-lg flex items-center justify-center">
            <div className="flex items-center gap-2">
              <Spinner />
              <span>Loading data ...</span>
            </div>
          </div>
        </>
      ) : (
        <div className="mb-3 grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="py-1 border-r">
            <small>Tanggal Tes:</small>
            <p>
              {offlineAssessment?.test_date
                ? moment(offlineAssessment?.test_date).format(
                    "dddd, D MMMM YYYY"
                  )
                : "-"}
            </p>
          </div>
          <div className="py-1 md:border-r">
            <small>Jenis Tes:</small> <br />
            <div
              className={twMerge(
                "text-xs text-white uppercase inline-block py-1 px-3 rounded",
                offlineAssessment?.method === "online" && "bg-pink-600",
                offlineAssessment?.method === "offline" && "bg-purple-600"
              )}
            >
              {offlineAssessment?.method}
            </div>
          </div>
          <div className="py-1 md:border-r">
            <small>Jumlah Peserta:</small> <br />
            <p>{offlineAssessment?.number_participant}</p>
          </div>
          <div className="py-1 ">
            <small>Total Harga:</small> <br />
            <p>
              {offlineAssessment?.total_price
                ? currency(offlineAssessment?.total_price)
                : "-"}
            </p>
          </div>
          <div className="py-1 border-r">
            <small>Tanggal Pengajuan:</small>
            <p>
              {offlineAssessment?.created_at
                ? moment(offlineAssessment?.created_at).format(
                    "dddd, D MMMM YYYY, HH:s"
                  )
                : "-"}
            </p>
          </div>
          <div className="py-1 border-r">
            <small>Klien / Perusahaan:</small>
            <p>
              {offlineAssessment?.client.name} -{" "}
              {offlineAssessment?.company.name}
            </p>
          </div>
          <div className="py-1 col-span-2 ">
            {offlineAssessment?.method === "online" && (
              <>
                <small>Link Meeting:</small>
                <p>
                  {offlineAssessment?.meeting_link ? (
                    <Link
                      to={offlineAssessment?.meeting_link}
                      target="_blank"
                      className="hover:underline"
                    >
                      {offlineAssessment?.meeting_link}
                    </Link>
                  ) : (
                    "-"
                  )}
                </p>
              </>
            )}
            {offlineAssessment?.method === "offline" && (
              <>
                <small>Psikolog dan Alamat:</small>
                <p>{offlineAssessment?.place?.psikolog?.name}</p>
                <small className="block leading-tight mt-1">
                  {offlineAssessment.place?.district_id?.name ?? ""},{" "}
                  {offlineAssessment.place?.district_id?.city?.name ?? ""},{" "}
                  {offlineAssessment.place?.district_id?.city?.province?.name ??
                    ""}
                  {" - "}
                  {offlineAssessment.place.address}
                </small>
              </>
            )}
          </div>
        </div>
      )}
      <Table>
        <Table.Thead>
          <Table.Th>#</Table.Th>
          <Table.Th>NIK</Table.Th>
          <Table.Th>Nama</Table.Th>
          <Table.Th>Email / Phone</Table.Th>
          <Table.Th>Jns. Asesmen</Table.Th>
          {/* <Table.Th>Addon</Table.Th> */}
          <Table.Th>Tujuan</Table.Th>
          <Table.Th>Konfirmasi</Table.Th>
        </Table.Thead>
        <Table.Tbody>
          {loadingParticipants ? (
            <Table.TrLoading cols={8} rows={5} />
          ) : (
            <>
              {participants?.data.length === 0 ? (
                <Table.Tr key={0}>
                  <Table.Td cols={8} className="py-3 text-center">
                    Tidak ada data
                  </Table.Td>
                </Table.Tr>
              ) : (
                <>
                  {participants?.data.map((item, key) => (
                    <Table.Tr>
                      <Table.Td>
                        {(
                          key +
                          1 +
                          participants.per_page *
                            (participants.current_page - 1)
                        ).toString()}
                      </Table.Td>
                      <Table.Td>{item.nik}</Table.Td>
                      <Table.Td className="cursor-pointer hover:underline">
                        <span
                          onClick={() =>
                            navigate(`/offline-asesmen/participant/${item.id}`)
                          }
                        >
                          {item.name}
                        </span>
                      </Table.Td>
                      <Table.Td>
                        <>
                          {item.email} / {item.phone}
                        </>
                      </Table.Td>
                      <Table.Td>{item.product?.name ?? "-"}</Table.Td>
                      <Table.Td>
                        {item.purpose
                          ? item.purpose
                              .split("_")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() + word.slice(1)
                              )
                              .join(" ")
                          : "-"}
                      </Table.Td>
                      <Table.Td>
                        {item.confirmed_at ? (
                          <div className="flex items-center gap-2">
                            <span>
                              {moment(item.confirmed_at).format(
                                "DD MMM YYYY, HH:ss"
                              )}
                            </span>
                          </div>
                        ) : (
                          <div className="flex items-center gap-2">
                            <span>Belum</span>
                          </div>
                        )}
                      </Table.Td>
                    </Table.Tr>
                  ))}
                </>
              )}
            </>
          )}
        </Table.Tbody>
      </Table>
    </Layout>
  );
};

export default DetailAsesmen;
